import { gql } from '@apollo/client';

import {
  GetAssemblyAiTokenDocument,
  type GetAssemblyAiTokenMutation,
  type GetAssemblyAiTokenMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation getAssemblyAIToken($input: SharedAssemblyAITokenInput!) {
      assemblyAIToken(input: $input) {
        token
        expiresAt
      }
    }
  `;
}

export const GET_ASSEMBLYAI_TOKEN = GetAssemblyAiTokenDocument;
export type getAssemblyAITokenMutation = GetAssemblyAiTokenMutation;
export type getAssemblyAITokenMutationVariables =
  GetAssemblyAiTokenMutationVariables;
export type GetAssemblyAITokenMutation = GetAssemblyAiTokenMutation;
export type GetAssemblyAITokenMutationVariables =
  GetAssemblyAiTokenMutationVariables;
